// 📤 BottomNav - Barre de navigation inférieure mobile
// Navigation style app mobile fixée en bas de l'écran
// Utilisé dans : src/components/layout/Navigation.jsx

import { Home, Mic2, ShoppingBag, Users, Award, Calendar } from 'lucide-react'
import { Link, useLocation } from 'react-router-dom'
import globalData from '@/locales/global.json'

/**
 * Barre de navigation inférieure pour mobile
 * Affichage en grille avec icônes et labels pour chaque page principale
 * Visible uniquement sur écrans < lg (1024px)
 * Indicateur visuel de la page active
 */
export default function BottomNav() {
  const location = useLocation()
  const { navigation } = globalData

  // Mapping des icônes par path
  const iconMap = {
    '/': Home,
    '/casting': Mic2,
    '/shop': ShoppingBag,
    '/pricing': Calendar,
    '/about': Users,
    '/partners': Award,
  }

  const isActive = (path) => location.pathname === path

  // Filtrer les items - exclure la boutique qui n'existe pas
  const visibleItems = navigation.mobile.filter(item => {
    // Exclure la boutique
    if (item.path === '/shop') {
      return false
    }
    return true
  })

  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 bg-white dark:bg-neutral-900 border-t border-neutral-200 dark:border-neutral-700 z-50 shadow-lg">
      <div className={`grid h-16`} style={{ gridTemplateColumns: `repeat(${visibleItems.length}, minmax(0, 1fr))` }}>
        {visibleItems.map((item) => {
          const active = isActive(item.path)
          const Icon = iconMap[item.path]
          return (
            <Link
              key={item.path}
              to={item.path}
              className={`relative flex flex-col items-center justify-center gap-1 transition-colors ${
                active
                  ? 'text-primary-600 dark:text-primary-400 bg-primary-50 dark:bg-primary-950/20' 
                  : 'text-neutral-600 dark:text-neutral-400 hover:text-primary-500 dark:hover:text-primary-400 hover:bg-neutral-50 dark:hover:bg-neutral-800'
              }`}
            >
              {active && (
                <span className="absolute top-0 left-0 right-0 h-0.5 bg-primary-500 rounded-b-full" />
              )}
              <Icon size={20} strokeWidth={active ? 2.5 : 2} />
              <span className={`text-[10px] ${active ? 'font-semibold' : 'font-medium'}`}>
                {item.label}
              </span>
            </Link>
          )
        })}
      </div>
    </nav>
  )
}
